<div class="container">
    <div class="header">
        {{ 'vessel.page.download-data.dialog-title' | translate }}
    </div>
    <div class="fieldset">
        <div class="input-container" (click)="openList()" #listInput>
            <input type="text" class="name input" readonly [ngModel]="displayedVersion" />
            <mat-icon svgIcon="arrow-down" class="icon" [ngStyle]="{ transform: showList ? 'rotate(180deg)' : '' }" />
        </div>

        <ng-container *ngIf="showList && versionsList?.length > 0">
            <div class="list-container" #listContainer>
                <div
                    *ngFor="let item of versionsList"
                    (click)="$event.stopPropagation(); handleVersionSelected(item)"
                    [ngClass]="{ highlighted: selectedVersion === item }"
                    class="list-item">
                    <div>
                        {{
                            isCurrentVersion(item.name)
                                ? ('dlg.current-version' | translate: { version: item.name })
                                : ('dlg.version' | translate: { version: item.name })
                        }}
                    </div>

                    <ng-container *ngIf="selectedVersion == item">
                        <mat-icon class="check-icon" svgIcon="check" />
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="button-container">
        <div class="button simple" (click)="close()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div class="button" (click)="selectVersion()">
            {{ 'dlg.download' | translate }}
        </div>
    </div>
</div>
